<template>
    <div>


      <b-nav fill>
          <b-nav-item :active="tabInfo=='M'" @click="tabInfo='M'">Movimentação</b-nav-item>
          <b-nav-item :active="tabInfo=='P'" @click="tabInfo='P'">Contas a Pagar</b-nav-item>
      </b-nav>

      <b-card v-show="tabInfo == 'P'">
        <account-component-payment :userId="propUserId"></account-component-payment>
      </b-card>

      <b-card v-show="tabInfo == 'M'">
        <account-component-movement :userId="propUserId" :accountId="propAccountId"></account-component-movement>
      </b-card>

    </div>
</template>

<script>

import axios from "axios";
import AccountComponentPayment from "./AccountComponentPayment.vue";
import AccountComponentMovement from "./AccountComponentMovement.vue";

export default {
  name: "AccountComponent",
  components: {
    AccountComponentPayment,
    AccountComponentMovement
  },
  props: {
    userId: Number,
    accountId: Number,
  },
  data() {
    return {
      tabInfo: 'M',
      

    }
  },
  computed: {
    propUserId() {
      if(!this.userId) return 0
      return this.userId
    },
    propAccountId() {
      if(!this.accountId) return 0
      return this.accountId
    },
  },
  methods: {
   
  },
  mounted: function() {
  }
  
};

</script>
